module.exports = __webpack_public_path__ + "img/soccer-field.faa4e1dd.png";